import { makeStyles } from '@material-ui/core'

export default makeStyles((theme) => ({
  main: {
    marginTop: ({ withNav }) => (withNav ? 0 : -64),
  },
}))
